import React from 'react';
import { motion } from 'framer-motion';
import { MoonIcon } from 'lucide-react';
export function OpeningHook() {
  return <section className="w-full bg-cream py-20 md:py-32" data-id="element-80">
      <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center" data-id="element-81">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="flex flex-col items-center" data-id="element-82">
          <MoonIcon className="w-8 h-8 text-terracotta mb-8 opacity-80" data-id="element-83" />
          <blockquote className="text-2xl md:text-3xl lg:text-4xl font-serif italic text-text-brown leading-relaxed" data-id="element-84">
            "Son las 3:11 AM. Estás despierta, empapada en sudor y con el
            corazón latiendo a mil por hora. Miras el techo calculando cuántas
            horas de 'vida' te quedan antes de que suene la alarma. Sabes que
            mañana será otro día de neblina mental, olvidando palabras sencillas
            y sobreviviendo a base de café y fuerza de voluntad."
          </blockquote>
          <div className="w-16 h-[1px] bg-taupe mt-12" data-id="element-85"></div>
        </motion.div>
      </div>
    </section>;
}